import { Component } from '@angular/core';
import { finalize } from 'rxjs';
import { ClienteUnicoAppDto, ClienteUnicoServiceProxy, PetDto } from '../services/service-proxy/service-proxies';
import { AppService } from '../services/app.service';
import { PetClinicalService, Recordatorio } from '../services/pet-clinical.service';

@Component({
  selector: 'app-mis-mascotas',
  templateUrl: './mis-mascotas.component.html',
  styleUrls: ['./mis-mascotas.component.scss']
})
export class MisMascotasComponent {

  isLoading = false;
  model? : ClienteUnicoAppDto | null;

  /** Proxima vacuna real por mascota (petId -> recordatorio o null). */
  vacunas = new Map<number, Recordatorio | null>();

  constructor(private clienteUnicoService : ClienteUnicoServiceProxy,
              private clinico : PetClinicalService,
              public appService : AppService) {}

  ngOnInit() {

    const idUnico = this.appService.idUnico!;

    // Se reusa lo que ya cargo la home si esta fresco, para no repetir la
    // llamada al entrar desde "Ver todas".
    this.model = this.appService.getClienteAppData(idUnico);

    if(this.model) { this.cargarVacunas(); return; }

    this.isLoading = true;
    this.clienteUnicoService
        .getForApp(idUnico, null)
        .pipe(finalize(() => this.isLoading = false))
        .subscribe(respuesta => {
          this.model = respuesta;
          this.appService.saveClienteAppData(this.model);
          this.cargarVacunas();
        });
  }

  /** Una llamada por mascota activa para su proximo control, en paralelo. */
  private cargarVacunas() {
    for (const pet of this.activas) {
      if (this.vacunas.has(pet.id)) continue;
      this.clinico.proximaVacuna(pet.id).subscribe(r => this.vacunas.set(pet.id, r));
    }
  }

  vacunaDe(pet : PetDto) : Recordatorio | null {
    return this.vacunas.get(pet.id) ?? null;
  }

  get activas() : PetDto[] {
    return (this.model?.pets ?? []).filter(p => !p.deceased);
  }

  /**
   * Las que fallecieron. PetDto trae deceased, asi que este bloque se alimenta
   * de datos reales y no de ejemplo.
   *
   * Sin ñ en el nombre a proposito: el lexer de expresiones de Angular no acepta
   * caracteres no ASCII en identificadores y rompe el template con NG5002.
   */
  get acompanaron() : PetDto[] {
    return (this.model?.pets ?? []).filter(p => p.deceased);
  }

  get hayAcompanaron() : boolean {
    return this.acompanaron.length > 0;
  }

  inicial(pet : PetDto) : string {
    return (pet.name ?? '?').trim().charAt(0).toUpperCase();
  }

  /**
   * "Siamesa · 2011". El prototipo muestra "Siamesa, 2011 – 2025", pero la
   * fecha de fallecimiento NO existe en PetDto: solo el booleano deceased. Se
   * muestra el año de nacimiento y nada mas, en vez de inventar el otro.
   */
  descripcion(pet : PetDto) : string {

    const raza = pet.breed?.name ?? pet.species?.name ?? '';
    const desde = pet.birthdate ? String(pet.birthdate.toDate().getFullYear()) : '';

    return [raza, desde].filter(x => x).join(' · ');
  }
}
